import React from 'react'

const AuthLoading = () => {
    return <h6>Authentication in progress...</h6>
};

export default AuthLoading;